<template>
  <v-btn
    v-if="$attrs.icon"
    v-bind="$attrs"
    :class="_class" />
  <v-btn
    v-else
    v-bind="$attrs"
    :class="_class">
    <slot />
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from "vue";
const props = defineProps<{
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  info?: boolean;
  cancel?: boolean;
  small?: boolean;
  large?: boolean;
  delete?: boolean;
}>();

const _class = computed(()=>({
  "occ-btn-primary": props.primary,
  "occ-btn-secondary": props.secondary,
  "occ-btn-tertiary": props.tertiary,
  "occ-btn-info": props.info,
  "occ-btn-cancel": props.cancel,
  "occ-btn-delete": props.delete,
  "small": props.small,
  "large": props.large,
}));
</script>

<style scoped lang="scss">
.v-btn {
  font-family: inherit;
  line-height: 1.34;
  letter-spacing: 0.2rem;
  text-align: center;
  transition-property: all;
  transition-duration: 0.15s;
  padding: 0.75rem 1.25rem;
  transition-timing-function: ease-in-out;
  :deep(.v-btn__content) {
    font-weight: var(--f-weight-bold);
    a {
      color: white;
      text-decoration: none;
    }
  }
  &.v-btn--icon {
    width: calc(var(--v-btn-height) + 15px);
    height: calc(var(--v-btn-height) + 15px);
    padding: 0;
  }
  &.small {
    font-size: 0.7rem;
    letter-spacing: 0.1rem;
    padding: var(--v-btn-padding-sm);

    &.v-btn--icon {
      padding: 0;
      width: calc(var(--v-btn-height) + 5px);
      height: calc(var(--v-btn-height) + 5px);
    }
  }
  &.large {
    font-size: 1rem;
    letter-spacing: 0.3rem;
    padding: var(--v-btn-padding-lg);
    &.v-btn--icon {
      padding: 0;
      font-size: 1.25rem;
      width: calc(var(--v-btn-height) + 22px);
      height: calc(var(--v-btn-height) + 22px);
    }
  }
}
:not(.v-btn--icon) {
  height: auto !important;
}

.occ-btn-tertiary {
  font-weight: var(--f-weight-bold);
  &.small {
    font-size: 0.8rem;
  }
}

.occ-btn-info {
  background-color: var(--c-cyan);
  color: white !important;
}

.occ-btn-primary {
  background-color: var(--c-teal);
  color: white !important;
  &.v-btn--disabled {
    background-color: darkgrey !important;
  }
}

.occ-btn-cancel {
  background-color: white;
  color: darkgrey;
  border: solid 2px darkgrey;
}

.occ-btn-secondary {
  background-color: white;
  color: var(--c-teal);
  border: solid 2px var(--c-teal);
}

.occ-btn-delete {
  background-color: white;
  color: var(--c-red);
  border: solid 2px var(--c-red);
}

.v-btn--variant-elevated {
  box-shadow: none;
}

.v-btn--icon {
  color: var(--c-teal);
  &.v-btn--density-default {
    &.small {
      width: calc(var(--v-btn-height));
      height: calc(var(--v-btn-height));
    }
  }
}

</style>